import React, { createContext, useCallback, useContext } from 'react';
import { freePublishingState } from '../lib/freePublishing.js';

const noop = () => {};
export const INACTIVE_FREE_PREVIEW = Object.freeze({
  active: false, readOnly: false, pendingVerification: false, mode: null,
  drafts: { ready: 0, limit: 3 }, imagesLimit: 1, trialDays: 7, entitlements: null,
  wall: null, openTrialWall: noop, closeTrialWall: noop, refresh: async () => null,
});
export const FreePreviewContext = createContext(INACTIVE_FREE_PREVIEW);
export function useFreePreview() { return useContext(FreePreviewContext); }
export function NotInFreePreview({ children, preview = null }) {
  const { active } = useFreePreview();
  return active ? preview : children;
}

/** Preview AI actions open the wall; Free own-content actions use their grants. */
export function usePreviewGuard() {
  const freePreview = useFreePreview();
  return useCallback((source, action, meta) => (...args) => {
    if (freePublishingState(freePreview.entitlements) && ['edit', 'publish', 'schedule'].includes(source)) return action?.(...args);
    if (freePreview.active) {
      freePreview.openTrialWall(source, typeof meta === 'function' ? meta(...args) : meta);
      return undefined;
    }
    return action?.(...args);
  }, [freePreview]);
}
